
import { Box, Button } from '@mui/material';

import { RouterLink } from '@components/navigation';

import type { PageComponent } from '../../pages.types';

// TODO: сделать красивую страницу 403
export const Error403Page: PageComponent = () => {
  return (
    <Box data-testid='403_page'>
      <h1 className='display-1 font-weight-bold'>404</h1>
      <p className='h1'>Страница не найдена.</p>
      <p className='h2 font-weight-normal mt-3 mb-4'>
        Страница, которую вы ищете, возможно, была удалена.
      </p>
      <RouterLink to='/'>
        <Button color='primary' size='large'>
          Вернуться на главную страницу
        </Button>
      </RouterLink>
    </Box>
  );
};
